const collator = new Intl.Collator('sv', {
  sensitivity: 'base',
  numeric: true
})

/**
 * Sort strings alphabetical ascending and put null/empty last
 */
export const sortAlphabeticalAsc = (a: string | null, b: string | null) => {
  const aEmpty = a === null || a === ''
  const bEmpty = b === null || b === ''

  if (aEmpty && bEmpty) return 0
  if (aEmpty) return 1
  if (bEmpty) return -1

  return collator.compare(a, b)
}

/**
 * Sort strings alphabetical descending and put null/empty last
 */
export const sortAlphabeticalDesc = (a: string | null, b: string | null) => {
  const aEmpty = a === null || a === ''
  const bEmpty = b === null || b === ''

  if (aEmpty && bEmpty) return 0
  if (aEmpty) return 1
  if (bEmpty) return -1

  return collator.compare(b, a)
}

/**
 * Sort numeric ascending and put null last
 * Use it as '.sort((a, b) => sortNumericAsc(a, b))'
 */
export const sortNumericAsc = (a: number | null, b: number | null) => {
  if (a === null && b === null) {
    return 0
  }

  if (a === null) {
    return 1
  }

  if (b === null) {
    return -1
  }

  return a - b
}

/**
 * Sort numeric descending and put null last
 * Use it as '.sort((a, b) => sortNumericDesc(a, b))'
 */
export const sortNumericDesc = (a: number | null, b: number | null) => {
  if (a === null && b === null) {
    return 0
  }

  if (a === null) {
    return 1
  }

  if (b === null) {
    return -1
  }

  return b - a
}

/**
 * Sort dates ascending and put null last
 * Use it as '.sort((a, b) => sortDateAsc(a, b))'
 */
export const sortDateAsc = (
  a: Date | string | null,
  b: Date | string | null
) => {
  if (a === null) {
    return 1
  }
  if (b === null) {
    return -1
  }

  const dateA = typeof a === 'string' ? new Date(a) : a
  const dateB = typeof b === 'string' ? new Date(b) : b

  if (dateA < dateB) {
    return -1
  }
  if (dateA > dateB) {
    return 1
  }

  return 0
}

/**
 * Sort dates descending and put null last
 * Use it as '.sort((a, b) => sortDateDesc(a, b))'
 */
export const sortDateDesc = (
  a: Date | string | null,
  b: Date | string | null
) => {
  if (a === null) {
    return 1
  }
  if (b === null) {
    return -1
  }

  const dateA = typeof a === 'string' ? new Date(a) : a
  const dateB = typeof b === 'string' ? new Date(b) : b

  if (dateA < dateB) {
    return 1
  }
  if (dateA > dateB) {
    return -1
  }

  return 0
}

/**
 * Sort a 2D layout into a 1D layout.
 * Use it as '.sort((a, b) => sortGridLayout(a, b))'
 */
export const sortGridLayout = (
  a: { width: number; height: number; x: number; y: number } | undefined,
  b: { width: number; height: number; x: number; y: number } | undefined
) => {
  if (a && b) {
    if (a.y !== b.y) {
      // sort by y first
      return a.y - b.y
    }

    // then by x
    return a.x - b.x
  }

  return 0
}
